var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"s-editor"}),_c('input',{ref:"file",attrs:{"type":"file","name":"file","hidden":"","accept":"image/*"}})])}
var staticRenderFns = []

export { render, staticRenderFns }